import request from '@/utils/request';
// 获取标签
export const getTagsList = (params: any) =>
  request({
    url: 'Tags/tagsList',
    method: 'GET',
    params
  });
  // add
export const addTags = (data: any) =>
  request({
    url: 'Tags/tags',
    method: 'POST',
    data
  });
export const editorTags = (data: any) =>
  request({
    url: 'Tags/tags',
    method: 'PUT',
    data
  });
export const delTags = (data: any) =>
  request({
    url: 'Tags/tags',
    method: 'DELETE',
    data
  });
